<template>
  <div :id="id" class="chart"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "lineChart",
  props: {
    id: {
      type: String,
      default: "lineChart",
    },
    option: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
      this.initChart();
      window.addEventListener("resize", this.myChart.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.myChart.resize);
  },
  methods: {
    initChart() {
      if (this.myChart) {
        this.myChart.setOption(this.option);
      }else {
        var chartDom = document.getElementById(this.id);
        this.myChart = echarts.init(chartDom);
        this.option && this.myChart.setOption(this.option);
      }
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>